import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcGroups = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M13.961 11.9a3.5 3.5 0 1 0-3.922 0A5.001 5.001 0 0 0 7 16.5v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a5.001 5.001 0 0 0-3.039-4.6Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.598 7.96a5.53 5.53 0 0 0 .503 3.54A6.978 6.978 0 0 0 5 16.5v1c0 .35.06.687.17 1H1.5a1 1 0 0 1-1-1V17a4.5 4.5 0 0 1 2.678-4.116 3 3 0 0 1 3.42-4.923ZM17.5 9c0 .9-.217 1.751-.6 2.5a6.977 6.977 0 0 1 2.1 5v1c0 .35-.06.687-.17 1h3.67a1 1 0 0 0 1-1V17a4.5 4.5 0 0 0-2.678-4.116 3 3 0 0 0-3.42-4.923c.064.336.098.684.098 1.039Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcGroups");

export { IcGroups };
//# sourceMappingURL=ic-groups.js.map
